import { createFeatureSelector } from '@ngrx/store';
import { ChatbotReducer, ChatbotState } from './chatbot.reducer';
import { DrawerReducer, DrawerState } from './drawer.reducer';

export const featureAlioName = 'Alio';

export interface AlioState {
  chatbot: ChatbotState;
  drawer: DrawerState;
}

export const moduleAlioReducers = {
  chatbot: ChatbotReducer,
  drawer: DrawerReducer,
};

export const getAlioState = createFeatureSelector<AlioState>(featureAlioName);
